<template>
    <div class="product-item">
        <figure class="image-wrap">
            <img :src="data.product.images.img_400x400" />
            <span class="curated-label" v-if="data.curation_id || data.product.curation_id">Curated</span>
        </figure>
            <div class="product-brand" v-if="data.brand_name">
            <span class="brand-label">Brand</span>
            <span class="brand-name">{{ data.brand_name }}</span>
        </div>
        <div class="product-name" v-tippy="{ content: data.product.name, delay: [500, 20] }">{{ data.product.name }}
        </div>
        <div class="product-sold-by" v-if="data.advertiser_name && $store.state.show_advertisement">Sold by: {{ data.advertiser_name }}</div>
        <div class="product-price" v-if="ProductData">{{ ProductData.lowest_price }}</div>
        <div class="product-data" v-if="data.add_from === 'storefront'">
            <div class="data-item">
                <div class="value">{{ formatNumber(data.views) }}</div>
                <div class="text">Product Views</div>
            </div>
            <div class="data-item">    
                <div class="value">{{ formatNumber(data.click) }}<i class="lig" v-if="data.click_include_shortlink_data"><svg-icon  name="lightning" /></i></div>
                <div class="text">Clicks</div>
            </div>
            <div class="data-item">  
                <div class="value">{{ formatNumber(data.sales) }}<i class="lig" v-if="data.sales_include_shortlink_data"><svg-icon  name="lightning" /></i></div>
                <div class="text">Sales</div>
            </div>
            <div class="data-item">
                <div class="value">${{ formatMoney(data.sales_value) }}<i class="lig" v-if="data.sale_value_include_shortlink_data"><svg-icon  name="lightning" /></i></div>
                <div class="text">Sales Value</div>
            </div>
            <!-- <div class="prodcut-desc" v-if="show_data_link && this.show_sortlink_text">
                *Includes Shortlink Data
            </div> -->
        </div>
        <div class="product-date">
            <span>Added: {{ $filters.momentFormat(data.created_at, 'MMM') + '&nbsp;' +
                $filters.momentFormat(data.created_at, 'D') + ', ' + $filters.momentFormat(data.created_at, 'YYYY')
                }}</span>
            <a class="icon" v-tippy="{ content: 'Open product source in new tab', delay: [500, 20] }" target="_blank"
                :href="data.product.product_url" @click.stop>
                <SvgIcon name="share" />
            </a>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/ui/SvgIcon.vue';
import formatMoney from '@/utils/formatMoney';
import handleProductData from '@/utils/HandleProductData';

export default {
    name: 'ProductItem',

    data() {
        return {
            ProductData: null,
        };
    },

    components: {
        SvgIcon,
    },

    // data() {
    //     return {

    //     }
    // },

    props: {
        data: {
            type: Object,
            default: {},
        },
        show_data_link:{
            type: [Number, Boolean],
            default: 0,
        }
    },

    computed:{
        //目前新增以下三欄位但沒用到8882
        show_sortlink_text(){
            return this.data && (this.data.sale_value_include_shortlink_data || this.data.sales_include_shortlink_data || this.data.click_include_shortlink_data)
        }

    },

    methods: {
        formatNumber(num) {
            return num ? num.toLocaleString('en-US') : '---';
        },

        share() {
            const obj = {};
            obj.url = 'test';
            this.EventBus.emit('open-share', obj);
        },

        formatMoney: formatMoney,
    },

    mounted() {
        this.ProductData = handleProductData(this.data.product);
    },
}
</script>
<style lang="scss">
.product-item {
    background: white;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    overflow: hidden;
    cursor: pointer;

    .image-wrap {
        cursor: pointer;
        position: relative;
        overflow: hidden;
        display: block;

        &:before {
            content: "";
            display: block;
            padding: 0 0 100%;
        }

        img {
            display: block;
            position: absolute;
            left: 0%;
            top: 0%;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .curated-label {
            position: absolute;
            right: 8px;
            bottom: 8px;
            z-index: 2;
            border-radius: 4px;
            height: 20px;
            background-color: var(--black-10);
            padding: 0 6px;
            display: flex;
            align-items: center;
            font: var(--font-med-10);
            color: var(--black-90);
        }
    }

    .product-brand {
        padding: 10px 8px 2px 8px;
        display: flex;
        align-items: center;
        gap: 4px;

        .brand-label {
            font: var(--font-med-10);
            color: var(--black-50);
        }

        .brand-name {
            font: var(--font-med-10);
            color: var(--black-90);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .product-name {
        height: 42px;
        padding: 2px 8px 0 8px;
        font: var(--font-fg-12);
        color: var(--black-90);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .product-sold-by {
        padding: 2px 8px 0 8px;
        font: var(--font-med-10);
        color: var(--black-50);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .product-price {
        padding: 4px 8px 10px 8px;
        font: var(--font-med-12);
        color: var(--black-90);
    }

    .product-data {
        padding: 8px;
        background: var(--bg-10);
        // display: inline-block;

        .data-item {
            width: 50%;
            display: inline-block;

            &:nth-child(3),
            &:nth-child(4) {
                padding-top: 8px;
            }

            .text {
                font-weight: 500;
                font-size: 12px;
                line-height: 14px;
                color: var(--black-50);
            }

            .value {
                font: var(--font-med-12);
                color: var(--black-90);

                display: flex;
                align-items: center;

                svg{
                    fill:var(--black-90);
                    margin-left: 2px; 
                    width: 12px;
                    height: 12px;
                }
            }
        }

        .prodcut-desc{
            width:100%;
            font-size: 12px;
            color: var(--black-50);
            margin-top: 8px;
        }
    }

    .product-date {
        padding: 14px 8px;
        font: var(--font-fg-12);
        color: var(--black-50);
        display: flex;

        &>span {
            flex: 1;
        }

        .icon {
            padding-left: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            svg {
                width: 12px;
                height: 12px;
                fill: var(--black-60);
            }
        }
    }
}
</style>
